import React from 'react';
import PropTypes from 'prop-types';

import {Chip} from 'views/components';
import {Translate} from 'views/module';

const RequirementStatus = (props) => {
  const {status} = props;

  return (
    <Chip
      label={
        <Translate expression={`career.jobDetail.NearbyCaregivers.Requirement.${String(status)}`} />
      }
      color={status === true ? 'success' : status === false ? 'error' : 'default'}
      size="small"
    />
  );
};

RequirementStatus.propTypes = {
  status: PropTypes.bool,
};

export default RequirementStatus;
